import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = [
  <path
    key="1"
    d="M8 14L15.9621 14.0005C16.5145 14.0005 17.0011 14.4484 17.0011 15.001C17.0011 15.5536 16.5533 16.0015 16.0009 16.0015L8 16C7.4476 16 6.99906 15.5536 6.99906 15.001C6.99906 14.4484 7.4476 14 8 14Z"
  />,
  <path
    key="2"
    fillRule="evenodd"
    clipRule="evenodd"
    d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V12H6V10H18V12H20V10C20 8.9 19.1 8 18 8ZM12 3C10.34 3 9 4.34 9 6V8H15V6C15 4.34 13.66 3 12 3Z"
  />,
  <path key="3" d="M4 20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V18H18V20H6V18H4V20Z" />,
];

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M7.50006 3.06506C6.70753 3.06506 6.06506 3.70753 6.06506 4.50006V5.93506H9.93506V4.50006C9.93506 3.70753 9.29259 3.06506 8.50006 3.06506H7.50006ZM4.93506 4.50006V5.93506H4.50006C3.63573 5.93506 2.93506 6.63573 2.93506 7.50006V8.00006C2.93506 8.3121 3.18802 8.56506 3.50006 8.56506C3.8121 8.56506 4.06506 8.3121 4.06506 8.00006V7.50006C4.06506 7.25981 4.25981 7.06506 4.50006 7.06506H11.5001C11.7403 7.06506 11.9351 7.25981 11.9351 7.50006V8.00006C11.9351 8.3121 12.188 8.56506 12.5001 8.56506C12.8121 8.56506 13.0651 8.3121 13.0651 8.00006V7.50006C13.0651 6.63573 12.3644 5.93506 11.5001 5.93506H11.0651V4.50006C11.0651 3.08345 9.91667 1.93506 8.50006 1.93506H7.50006C6.08345 1.93506 4.93506 3.08345 4.93506 4.50006ZM3.50006 12.4351C3.8121 12.4351 4.06506 12.688 4.06506 13.0001V13.5001C4.06506 13.7403 4.25981 13.9351 4.50006 13.9351H11.5001C11.7403 13.9351 11.9351 13.7403 11.9351 13.5001V13.0001C11.9351 12.688 12.188 12.4351 12.5001 12.4351C12.8121 12.4351 13.0651 12.688 13.0651 13.0001V13.5001C13.0651 14.3644 12.3644 15.0651 11.5001 15.0651H4.50006C3.63573 15.0651 2.93506 14.3644 2.93506 13.5001V13.0001C2.93506 12.688 3.18802 12.4351 3.50006 12.4351ZM5.50006 9.93506C5.18802 9.93506 4.93506 10.188 4.93506 10.5001C4.93506 10.8121 5.18802 11.0651 5.50006 11.0651H10.5001C10.8121 11.0651 11.0651 10.8121 11.0651 10.5001C11.0651 10.188 10.8121 9.93506 10.5001 9.93506H5.50006Z"
  />
);

export const LockIndeterminateIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="LockIndeterminate" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
